import { render, staticRenderFns } from "./Utama.vue?vue&type=template&id=9de60298&"
import script from "./Utama.vue?vue&type=script&lang=js&"
export * from "./Utama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports